'use strict';

module.exports = require('../../date-picker/locale/zh_CN');


/*****************
 ** WEBPACK FOOTER
 ** ./components/calendar/locale/zh_CN.js
 ** module id = 182
 ** module chunks = 0
 **/